import { ActionPointInfo, Controller, IActionPointInfo, IDynamicLoader, Loader, Toolbar } from '@tencent/workbench';
import { config, TOOLBAR_ITEMS } from './config';
import { ChangeTemplateMoreFeature } from './change-theme-template-more-feature';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
})
export class ChangeThemeTemplateMoreController {
    public constructor(@Loader(ChangeTemplateMoreFeature) private loader: IDynamicLoader<ChangeTemplateMoreFeature>) {
    }

    private get feature() {
        return this.loader.instance!;
    }

    @Toolbar(config.id, 'onClick')
    public content(@ActionPointInfo() info: IActionPointInfo) {
        this.feature.onClick(info);
    }

    @Toolbar(config.id, 'shouldHide')
    public shouldTemplateMoreHide() {
        return !(appConfigInstance.getConfig(ToolbarFileMenuConfig.changeTemplateMore as any) ?? true);
    }

    @Toolbar(config.id, 'shouldDisabled')
    public shouldDisabled() {
        return this.feature.shouldDisabled(config.id);
    }
}
